import { ElementsFactories } from 'react-planner';

const info = {
  title: 'Water Pipe',
  tag: ['pipe'],
  description: 'Water Pipe',
  image: require('./pipe-water.png'),
  visibility: {
    catalog: true,
    layerElementsVisible: true
  }
};

export default ElementsFactories.PipeFactoryWater('water-pipe', info, null);

